const Features2 = () => {
  return (
    <div className="bg-gray-50">
      <div className="py-16">
        <div className="container mx-auto px-4">
          <div className="flex flex-col gap-12 items-center self-stretch shrink-0 flex-nowrap relative">
            <div className="text-center">
              <h2 className="text-3xl md:text-4xl font-semibold text-gray-900 mb-5">
                Everything you need to host successful events
              </h2>
              <p className="text-xl text-gray-600">
                Simple, powerful tools designed for event organizers
              </p>
            </div>

            <div className="flex w-full max-w-[1080px] gap-8 md:gap-18 lg:gap-18 items-center shrink-0 flex-wrap md:flex-nowrap relative flex-col md:flex-row">
              <div className="flex flex-col gap-10 justify-center items-start self-stretch grow shrink basis-0 flex-nowrap relative">
                <div className="flex flex-col gap-6 items-start self-stretch shrink-0 flex-nowrap relative">
                  <div className="flex flex-row gap-4 items-center">
                    <div className="w-12 h-12 bg-[url(/host/images/ticket-03.svg)] bg-contain bg-center bg-no-repeat" />
                    <h3 className="text-xl md:text-2xl font-semibold leading-tight text-gray-900 whitespace-normal md:whitespace-nowrap">
                      Ticketing & check-in
                    </h3>
                  </div>
                  <div className="flex flex-col gap-4 items-start self-stretch shrink-0 flex-nowrap pl-3">
                    <div className="flex gap-3 items-start self-stretch shrink-0 flex-nowrap relative">
                      <div className="flex w-7 h-7 gap-2.5 items-start shrink-0 flex-nowrap bg-[url(/host/images/check-icon.svg)] bg-cover bg-no-repeat relative" />
                      <div className="flex flex-col gap-2 items-center grow shrink-0 basis-0 flex-nowrap relative">
                        <span className="self-stretch shrink-0 basis-auto text-md md:text-lg font-normal leading-[30px] text-gray-900 relative text-left whitespace-normal">
                          Multiple check-in options for smooth entry
                        </span>
                      </div>
                    </div>
                    <div className="flex gap-3 items-start self-stretch shrink-0 flex-nowrap relative">
                      <div className="flex w-7 h-7 gap-2.5 items-start shrink-0 flex-nowrap bg-[url(/host/images/check-icon.svg)] bg-cover bg-no-repeat relative" />
                      <div className="flex flex-col gap-2 items-center grow shrink-0 basis-0 flex-nowrap relative">
                        <span className="self-stretch shrink-0 basis-auto text-md md:text-lg font-normal leading-[30px] text-gray-900 relative text-left whitespace-normal">
                          Unlimited number of tickets per event
                        </span>
                      </div>
                    </div>
                    <div className="flex gap-3 items-start self-stretch shrink-0 flex-nowrap relative">
                      <div className="flex w-7 h-7 gap-2.5 items-start shrink-0 flex-nowrap bg-[url(/host/images/check-icon.svg)] bg-cover bg-no-repeat relative" />
                      <div className="flex flex-col gap-2 items-center grow shrink-0 basis-0 flex-nowrap relative">
                        <span className="self-stretch shrink-0 basis-auto text-md md:text-lg font-normal leading-[30px] text-gray-900 relative text-left whitespace-normal">
                          QR code and digital ticket management
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="flex flex-col gap-6 items-start self-stretch shrink-0 flex-nowrap relative">
                  <div className="flex flex-row gap-4 items-center">
                    <div className="w-12 h-12 bg-[url(/host/images/users-01.svg)] bg-contain bg-center bg-no-repeat" />
                    <h3 className="text-xl md:text-2xl font-semibold leading-tight text-gray-900 whitespace-normal md:whitespace-nowrap">
                      Community building
                    </h3>
                  </div>
                  <div className="flex flex-col gap-4 items-start self-stretch shrink-0 flex-nowrap pl-3">
                    <div className="flex gap-3 items-start self-stretch shrink-0 flex-nowrap relative">
                      <div className="flex w-7 h-7 gap-2.5 items-start shrink-0 flex-nowrap bg-[url(/host/images/check-icon.svg)] bg-cover bg-no-repeat relative" />
                      <div className="flex flex-col gap-2 items-center grow shrink-0 basis-0 flex-nowrap relative">
                        <span className="self-stretch shrink-0 basis-auto text-md md:text-lg font-normal leading-[30px] text-gray-900 relative text-left whitespace-normal">
                          Customizable organizer profiles
                        </span>
                      </div>
                    </div>
                    <div className="flex gap-3 items-start self-stretch shrink-0 flex-nowrap relative">
                      <div className="flex w-7 h-7 gap-2.5 items-start shrink-0 flex-nowrap bg-[url(/host/images/check-icon.svg)] bg-cover bg-no-repeat relative" />
                      <div className="flex flex-col gap-2 items-center grow shrink-0 basis-0 flex-nowrap relative">
                        <span className="self-stretch shrink-0 basis-auto text-md md:text-lg font-normal leading-[30px] text-gray-900 relative text-left whitespace-normal">
                          Unlimited messages to followers
                        </span>
                      </div>
                    </div>
                    <div className="flex gap-3 items-start self-stretch shrink-0 flex-nowrap relative">
                      <div className="flex w-7 h-7 gap-2.5 items-start shrink-0 flex-nowrap bg-[url(/host/images/check-icon.svg)] bg-cover bg-no-repeat relative" />
                      <div className="flex flex-col gap-2 items-center grow shrink-0 basis-0 flex-nowrap relative">
                        <span className="self-stretch shrink-0 basis-auto text-md md:text-lg font-normal leading-[30px] text-gray-900 relative text-left whitespace-normal">
                          Token-gated community features
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="flex flex-col gap-6 items-start self-stretch shrink-0 flex-nowrap relative">
                  <div className="flex flex-row gap-4 items-center">
                    <div className="w-12 h-12 bg-[url(/host/images/bar-chart-05.svg)] bg-contain bg-center bg-no-repeat" />
                    <h3 className="text-xl md:text-2xl font-semibold leading-tight text-gray-900 whitespace-normal md:whitespace-nowrap">
                      Event management
                    </h3>
                  </div>
                  <div className="flex flex-col gap-4 items-start self-stretch shrink-0 flex-nowrap pl-3">
                    <div className="flex gap-3 items-start self-stretch shrink-0 flex-nowrap relative">
                      <div className="flex w-7 h-7 gap-2.5 items-start shrink-0 flex-nowrap bg-[url(/host/images/check-icon.svg)] bg-cover bg-no-repeat relative" />
                      <div className="flex flex-col gap-2 items-center grow shrink-0 basis-0 flex-nowrap relative">
                        <span className="self-stretch shrink-0 basis-auto text-md md:text-lg font-normal leading-[30px] text-gray-900 relative text-left whitespace-normal">
                          Dedicated dashboard to manage each event
                        </span>
                      </div>
                    </div>
                    <div className="flex gap-3 items-start self-stretch shrink-0 flex-nowrap relative">
                      <div className="flex w-7 h-7 gap-2.5 items-start shrink-0 flex-nowrap bg-[url(/host/images/check-icon.svg)] bg-cover bg-no-repeat relative" />
                      <div className="flex flex-col gap-2 items-center grow shrink-0 basis-0 flex-nowrap relative">
                        <span className="self-stretch shrink-0 basis-auto text-md md:text-lg font-normal leading-[30px] text-gray-900 relative text-left whitespace-normal">
                          AI-powered event descriptions
                        </span>
                      </div>
                    </div>
                    <div className="flex gap-3 items-start self-stretch shrink-0 flex-nowrap relative">
                      <div className="flex w-7 h-7 gap-2.5 items-start shrink-0 flex-nowrap bg-[url(/host/images/check-icon.svg)] bg-cover bg-no-repeat relative" />
                      <div className="flex flex-col gap-2 items-center grow shrink-0 basis-0 flex-nowrap relative">
                        <span className="self-stretch shrink-0 basis-auto text-md md:text-lg font-normal leading-[30px] text-gray-900 relative text-left whitespace-normal">
                          Attendee questionnaires and feedback
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="w-full max-w-full px-4 md:px-6 lg:w-[597px] relative self-center overflow-hidden">
                <img  
                    src="/host/images/feature-showcase.webp" 
                    alt="Screenshot of the Peatix website as viewed on a smartphone" 
                    className="w-full h-auto object-contain mx-auto"
                    style={{ maxWidth: '100%' }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Features2; 